import { UserJourneyEntry } from '../../UserJourney/types';

export enum LeadFormIntent {
  CONTACT = 'Buying Life Insurance',
  RECRUIT = 'Sales Career',
}

export interface LeadFormValues {
  intent: LeadFormIntent;
  firstName: string;
  lastName: string;
  phone: string;
  zipCode: string;
  email: string;
  videoCall: boolean;
  contactDay: string;
  contactPeriod: string;
  contactTime: string;
  businessName: string;
  businessSize: string;
  interests: string[];
  careerGoals: string[];
  careerExperience: string[];
  careerStrengths: string[];
  _producerId: string;
  _refPage: string;
  _sessionId: string;
  _userJourney: UserJourneyEntry[];
  _utmParams: Record<string, string> | null;
}

export enum LeadFormMode {
  /**
   * First, last, phone, email, zipCode, interestedIn
   */
  GENERIC = 'generic',
  /**
   * Generic form minus 'interestedIn'
   */
  INDIVIDUAL = 'individual',
  /**
   * Product + contact time, biz name, and biz size
   */
  BUSINESS = 'business',
  /**
   * Product + video call checkbox & contact day/time
   */
  PRODUCER = 'producer',
  /**
   * Product + recruiting form
   */
  RSM = 'rsm',
  /**
   * Recruiting form only
   */
  RECRUITING = 'recruiting',
}
